import { render } from "./PaymentsSummary.vue?vue&type=template&id=64732b57"
import script from "./PaymentsSummary.vue?vue&type=script&lang=js"
export * from "./PaymentsSummary.vue?vue&type=script&lang=js"
script.render = render

export default script